
import React from "react";
import { ModernTemplateLogic } from "./components/ModernTemplateLogic";
import type { ModernTemplateProps } from "./types";

const ModernTemplate: React.FC<ModernTemplateProps> = React.memo((props) => {
  const { meetingLink } = props;

  // Early return if no meeting link
  if (!meetingLink) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-xl font-semibold mb-2">Meeting Link Not Found</h2>
          <p className="text-muted-foreground">Unable to load meeting details.</p>
        </div>
      </div>
    );
  }

  // All hook logic is now in ModernTemplateLogic
  return <ModernTemplateLogic {...props} />;
});

ModernTemplate.displayName = 'ModernTemplate';

export { ModernTemplate };
export default ModernTemplate;
